import { get } from 'lodash';

const root = (state) =>
  get(state, 'ControlInformationState.cnVersionInformation');

export const getCNVersionInformation = (state) =>
  get(root(state), 'cnVersionInformation');

export const getCNVersionInformationFetchError = (state) =>
  get(root(state), 'cnVersionInformationFetchError');

export const getCNVersionInformationFetchLoading = (state) =>
  get(root(state), 'cnVersionInformationFetchLoading');

export const getCNVersionUpdateEnqueueLoading = (state) =>
  get(root(state), 'cnVersionUpdateEnqueueLoading');
export const getCNVersionUpdateEnqueueSuccess = (state) =>
  get(root(state), 'cnVersionUpdateEnqueuedSuccessfully');
export const getCNVersionUpdateEnqueueError = (state) =>
  get(root(state), 'cnVersionUpdateEnqueueError');
export const getCNVersionUpdateLoading = (state) =>
  get(root(state), 'cnUpdateLoading');
export const getCNPreviewLoading = (state) =>
  get(root(state), 'cnPreviewLoading');
export const getNotifications = (state) =>
  get(state, 'GlobalUIState.notifications');
export const getCNPreviewEnqueuedSuccessfully = (state) =>
  get(root(state), 'cnPreviewEnqueuedSuccessfully');
export const getCNPreviewEnqueuedLoading = (state) =>
  get(root(state), 'cnPreviewEnqueuedLoading');



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/CNVersionInformation/selectors.js